export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export const DEFAULT_STORE_TIMINGS = {
  mon: { startTime: '09:00', endTime: '17:00' },
  tue: { startTime: '09:00', endTime: '17:00' },
  wed: { startTime: '09:00', endTime: '17:00' },
  thu: { startTime: '09:00', endTime: '17:00' },
  fri: { startTime: '09:00', endTime: '17:00' },
};
